// PsyPractice, hukuki belgeler / Srpski.
//
// Bölüm sırası, başlık numaraları ve hukuki iddialar TÜM dillerde aynıdır; esasa
// ilişkin bir değişiklik bütün dillerde birlikte yapılır ve shared.ts'teki
// LEGAL_VERSION birlikte artar; aksi hâlde kullanıcının onayladığı sürüm ile
// okuduğu metin ayrışır. Yalnızca çeviri eklemek sürümü ARTIRMAZ.
import { LEGAL_VERSION, MERCHANT, type LegalDoc } from "./shared";

// İşletme türünün ADI dile bağlıdır, resmî bilgiler (ad, adres, vergi) değildir;
// bu yüzden shared.ts'te değil, her dilin kendi dosyasında durur.
const OWNER_TYPE = "Preduzetnik";

const OWNER = 'PsyPractice (u daljem tekstu „Platforma“ ili „Rukovalac“)';

export const DOCS: LegalDoc[] = [
  {
    id: "terms",
    title: "Uslovi korišćenja i odricanje od odgovornosti",
    description:
      "Priroda i granice usluge, šta ona ne zamenjuje, obaveze korisnika i sveobuhvatno odricanje kojim se sva odgovornost prenosi na korisnika.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "1. Strane i prihvatanje",
        paras: [
          `Ovi Uslovi korišćenja zaključuju se između ${OWNER} i svakog fizičkog ili pravnog lica koje pristupa Platformi ili je koristi („Korisnik“). Otvaranjem naloga, prijavom ili korišćenjem Platforme na bilo koji način, Korisnik potvrđuje da je ove Uslove pročitao, razumeo i da ih bezuslovno prihvata i obavezuje se da ih se u celosti pridržava. Ko ne prihvata ove Uslove, ne sme da koristi Platformu.`,
        ],
      },
      {
        heading: "2. Priroda i granice usluge",
        bullets: [
          "PsyPractice je softver za SIMULACIJU pacijenata uz podršku veštačke inteligencije, koji studentima psihologije i kliničarima na početku karijere omogućava da u bezbednom okruženju sami vežbaju vođenje razgovora i da to vežbanje beleže.",
          "PsyPractice nije usluga obrazovanja ni nastave; to je softverski alat kojim korisnik sam sprovodi i beleži sopstveno vežbanje. Platforma ne pruža časove, nastavni plan, ispite ni dokumente i ne dodeljuje nikakvo zvanje, kvalifikaciju ni ovlašćenje.",
          "Simulirani „pacijent“ nije stvarni klijent; njegove odgovore sintetizuje veštačka inteligencija, oni mogu biti pogrešni, nepotpuni, nedosledni ili obmanjujući i ne nose nikakvu tvrdnju o kliničkoj tačnosti ili istinitosti.",
        ],
      },
      {
        heading: "2.1. Šta Platforma ne zamenjuje",
        bullets: [
          "NIJE prava terapija ni savetovanje i ne zamenjuje nijednu sesiju vođenu sa stvarnim klijentom.",
          "NIJE zamena za kliničku superviziju. Izveštaji sa povratnim informacijama koje proizvodi supervizor AI automatski su generisan tekst; oni nisu stručno mišljenje, zvanična procena ni ocena.",
          "NIJE dijagnostički instrument, instrument za skrining ni za procenu; nijedan rezultat Platforme ne sme se koristiti za dijagnostičko ili kliničko odlučivanje o bilo kojoj stvarnoj osobi.",
          "NE SME se koristiti u krizama ni hitnim situacijama. U slučaju suicidalnih misli, rizika od povređivanja sebe ili drugih ili bilo koje slične hitne situacije, zatvorite Platformu i odmah se obratite lokalnoj hitnoj službi ili nadležnoj zdravstvenoj ustanovi.",
          "NIJE izvor profesionalne kompetentnosti, licence, zvanja ni ovlašćenja; vreme provedeno na Platformi i njeni rezultati ne smeju se predstavljati nijednoj instituciji kao dokaz kvalifikacije.",
        ],
      },
      {
        heading: "3. Izjave i obaveze Korisnika",
        bullets: [
          "Korisnik se obavezuje da Platformu koristi isključivo u zakonitim i etičkim okvirima, u svrhu razvoja sopstvene profesionalne prakse.",
          "Korisnik se saglašava da NEĆE unositi nikakve podatke STVARNIH pacijenata/klijenata, identifikujuće podatke ni posebne kategorije zdravstvenih podataka bilo koje osobe; sve pravne posledice takvog postupanja snosi isključivo Korisnik.",
          "Korisnik se obavezuje da nijedan rezultat dobijen sa Platforme neće koristiti za dijagnostiku, lečenje, intervenciju ili kliničko odlučivanje u vezi sa bilo kojom stvarnom osobom.",
          "Korisnik je isključivo odgovoran za sopstvenu profesionalnu kompetentnost, obim ovlašćenja i usklađenost sa važećim profesionalnim i etičkim propisima.",
          "Bezbednost naloga, poverljivost lozinke i sve aktivnosti izvršene pod Korisnikovim nalogom odgovornost su Korisnika.",
          "Nalog je lični; Korisnik se obavezuje da ga neće deliti sa drugima i da neće koristiti Platformu automatizovanim sredstvima (botovi, skripte i sl.). Korišćenje plaćenih planova podleže ograničenju fer korišćenja (trenutno 60 sesija po kalendarskom mesecu), bliže uređenom Ugovorom o prodaji na daljinu.",
        ],
      },
      {
        heading: "4. Sva odgovornost je na Korisniku (odricanje)",
        paras: [
          "Platforma se pruža „TAKVA KAKVA JESTE“ i „PREMA DOSTUPNOSTI“, bez ikakve izričite ili prećutne garancije (uključujući neprekidan rad, odsustvo grešaka, podobnost za određenu svrhu, tačnost ili ažurnost).",
          "Korisnik prihvata i obavezuje se da je ISKLJUČIVO i LIČNO odgovoran za svaku direktnu, indirektnu, slučajnu, posebnu ili posledičnu štetu (uključujući materijalnu, nematerijalnu, štetu po profesionalni ugled, gubitak podataka, gubitak prihoda i štetu nanetu trećim licima) koja proistekne iz korišćenja Platforme ili nemogućnosti njenog korišćenja, iz oslanjanja na rezultate veštačke inteligencije ili iz primene tih rezultata na bilo koji način.",
          "U najvećoj meri dozvoljenoj važećim pravom, Korisnik se ovim neopozivo i bezuslovno ODRIČE, sada i unapred, svih zahteva, tužbi i prava na naknadu koje bi mogao istaći protiv Platforme, njenih vlasnika, zaposlenih, programera, poslovnih partnera i pružalaca usluga u vezi sa bilo kojom štetom sa kojom bi se mogao suočiti u slučaju bilo kog nepovoljnog ishoda.",
          "Korisnik se dalje obavezuje da Platformu u potpunosti obešteti (naknadi štetu) za sve zahteve, štete, kazne i troškove (uključujući advokatske troškove) ukoliko se Platformi obrati bilo koje treće lice ili institucija usled Korisnikove sopstvene krivice, nemara ili korišćenja suprotnog ovim Uslovima.",
        ],
      },
      {
        heading: "5. Ograničenje odgovornosti",
        paras: [
          "Ne dovodeći u pitanje prinudne odredbe važećeg prava, ukupna pravna odgovornost Platforme u svakom slučaju je ograničena na iznos koji je Korisnik stvarno platio Platformi u 12 meseci koji prethode događaju koji je dao povoda za odgovarajući zahtev. Kada je korišćenje besplatno, taj iznos je nula.",
        ],
      },
      {
        heading: "6. Intelektualna svojina, izmene i raskid",
        bullets: [
          "Sva prava intelektualne svojine na Platformi, njenom softveru, dizajnu, šablonima slučajeva pacijenata i sadržaju pripadaju Platformi.",
          "Sva prenosiva imovinska prava intelektualne svojine na bilo kom sadržaju koji Korisnik kreira na Platformi (uključujući poruke terapeuta koje piše, transkripte sesija i materijale izvedene iz njih) smatraju se ustupljenim Platformi isključivo, trajno i bez naknade u trenutku kreiranja tog sadržaja; Platforma može ovaj sadržaj koristiti, umnožavati i obrađivati širom sveta i bez ograničenja u bilo koju svrhu, uključujući pružanje usluge, generisanje povratnih informacija i unapređenje i razvoj sistema (uključujući unapređenje mašinskim učenjem). Ovo ustupanje ne utiče na prava Korisnika u vezi sa ličnim podacima prema važećem pravu o zaštiti podataka (GDPR / KVKK), koja ostaju zadržana.",
          "Platforma zadržava pravo da ove Uslove i obim usluge izmeni, obustavi ili ukine u bilo kom trenutku, bez prethodnog obaveštenja.",
          "U slučaju kršenja ovih Uslova, Platforma može da suspenduje ili zatvori nalog bez prethodnog obaveštenja.",
        ],
      },
      {
        heading: "7. Merodavno pravo i nadležnost",
        paras: [
          "Na ove Uslove primenjuje se pravo Republike Turske. Za svaki spor koji može nastati nadležni su sudovi i izvršni organi Republike Turske.",
          "Za potrošače sa prebivalištem u Evropskoj uniji zadržana je zaštita koju pružaju prinudne odredbe o zaštiti potrošača njihove zemlje prebivališta i njihova prava na zaštitu podataka prema GDPR-u; ovaj izbor prava ne poništava te prinudne odredbe.",
        ],
      },
    ],
  },
  {
    id: "privacy",
    title: "Politika privatnosti",
    description:
      "GDPR kao osnovni standard; obrađivani podaci, pravni osnovi, hostovanje u EU, međunarodni prenosi (pružalac AI usluge) i klauzula o prekograničnom prenosu prema čl. 9 KVKK za korisnike u Turskoj.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          `Ova Politika privatnosti objašnjava kako se lični podaci obrađuju u okviru Platforme kojom upravlja ${OWNER}. Kao osnovni standard zaštite podataka, politika sledi Opštu uredbu EU o zaštiti podataka (GDPR / 2016/679); za korisnike koji se nalaze u Turskoj dodatno se primenjuje turski Zakon o zaštiti ličnih podataka br. 6698 (KVKK), posebno njegov član 9 o prenosu u inostranstvo. Obaveštenje po KVKK i Izjava o izričitoj saglasnosti sastavni su delovi ove politike.`,
        ],
      },
      {
        heading: "Rukovalac podacima i lokacija hostovanja",
        bullets: [
          "Rukovalac podacima: PsyPractice. Zahtevi lica na koja se podaci odnose obrađuju se preko kontakt kanala objavljenog na Platformi (kontakt imejl: info@psycora.com).",
          "Hostovanje: Platforma i njena baza podataka hostovane su unutar Evropske unije, u data centru u Holandiji (Oracle Cloud). Za korisnike koji se nalaze u EU/EEP, podaci se obrađuju i čuvaju unutar EU.",
          "Pružalac hostinga postupa isključivo kao obrađivač, na osnovu zaključenog Ugovora o obradi podataka (DPA).",
        ],
      },
      {
        heading: "Prikupljeni podaci",
        bullets: [
          "Podaci o nalogu: ime, imejl, heširana lozinka, podaci o pretplati/planu.",
          "Podaci o korišćenju: kreirane sesije, transkripti sesija, generisani slučajevi pacijenata, izveštaji supervizora sa povratnim informacijama.",
          "Tehnički podaci: zapisi sesija, IP adresa, pregledač/jezička podešavanja, dnevnici ograničenja učestalosti i bezbednosti.",
        ],
      },
      {
        heading: "Svrhe obrade i pravni osnov (čl. 6 GDPR)",
        bullets: [
          "Izvršenje ugovora (čl. 6(1)(b)): otvaranje naloga, vođenje sesija, pamćenje pacijenta kroz više sesija, procena supervizora, upravljanje pretplatom i ograničenjima korišćenja.",
          "Legitimni interes (čl. 6(1)(f)): bezbednost, sprečavanje zloupotrebe, unapređenje sistema i otklanjanje grešaka.",
          "Zakonska obaveza (čl. 6(1)(c)): čuvanje/izveštavanje koje proizlazi iz propisa.",
          "Saglasnost (čl. 6(1)(a)): obrada za analitiku/unapređenje proizvoda koja nije strogo neophodna za uslugu i, gde je potrebno, prenos izvan EU/EEP.",
        ],
      },
      {
        heading: "Međunarodni prenosi",
        paras: [
          "Budući da je hostovanje unutar EU (Holandija), podaci korisnika iz EU/EEP po pravilu se obrađuju unutar EU, bez prenosa u treću zemlju na tom sloju. Međutim, radi generisanja odgovora veštačke inteligencije, sadržaj sesija i upiti prenose se pružaocu AI usluge (Anthropic), čija se infrastruktura za obradu može nalaziti izvan EU/EEP (npr. u Sjedinjenim Američkim Državama).",
          "Takvi prenosi izvan EU/EEP oslanjaju se na odgovarajuće zaštitne mere prema čl. 44 i dalje GDPR, posebno na standardne ugovorne klauzule Evropske komisije (SCC), a sa pružaocem se zaključuje ugovor o obradi podataka (DPA). Platforma NE prodaje lične podatke u marketinške svrhe; podaci se ne dele sa trećim stranama osim kada je to strogo neophodno za pružanje usluge (zadržani su zakoniti zahtevi nadležnih organa).",
        ],
      },
      {
        heading: "Za korisnike u Turskoj: čl. 9 KVKK (prenos u inostranstvo)",
        paras: [
          "Lični podaci korisnika koji se nalaze u Turskoj prenose se izvan Turske jer je hostovanje u Holandiji (EU), a mogu se preneti i kompaniji Anthropic radi AI obrade. Ovi prenosi potpadaju pod čl. 9 KVKK i oslanjaju se na odgovarajuće zaštitne mere (standardni ugovor / obavezujuću izjavu koje objavljuje Odbor) ili, gde je potrebno, na vašu izričitu saglasnost. Obim, primaoci i svrha prenosa detaljno su opisani u Obaveštenju po KVKK i Izjavi o izričitoj saglasnosti.",
        ],
      },
      {
        heading: "Prava lica na koja se podaci odnose (čl. 15 do 22 GDPR)",
        bullets: [
          "Pristup, ispravka, brisanje („pravo na zaborav“) i ograničenje obrade.",
          "Prenosivost podataka: dobijanje podataka koje ste dali u strukturiranom, uobičajeno korišćenom i mašinski čitljivom formatu.",
          "Prigovor: prigovor na obradu zasnovanu na legitimnom interesu i na direktni marketing.",
          "Prava u vezi sa isključivo automatizovanim pojedinačnim odlučivanjem/profilisanjem.",
          "Opoziv saglasnosti u bilo kom trenutku za obradu zasnovanu na saglasnosti (opoziv ne utiče na zakonitost obrade izvršene do tog trenutka).",
          "Pravo na podnošenje pritužbe nadzornom organu: nadležnom organu za zaštitu podataka u EU; Upravi za zaštitu ličnih podataka (KVKK) u Turskoj.",
        ],
      },
      {
        heading: "Čuvanje i bezbednost",
        bullets: [
          "Podaci se čuvaju onoliko dugo koliko to svrha obrade zahteva i u rokovima propisanim važećim pravom; po isteku roka brišu se ili anonimizuju.",
          "Osetljiva polja (npr. lozinka, kodovi za potvrdu i za resetovanje) čuvaju se šifrovana/heširana; pristup je zasnovan na dozvolama.",
          "Budući da nijedan način prenosa ni čuvanja nije 100% bezbedan, apsolutna bezbednost ne može se garantovati.",
        ],
      },
      {
        heading: "Zabrana unošenja podataka stvarnih pacijenata",
        paras: [
          "Platforma je softver za simulaciju; unošenje ličnih/zdravstvenih podataka stvarnih klijenata je zabranjeno. Sva odgovornost koja proistekne iz toga što Korisnik unese podatke suprotno ovoj zabrani snosi isključivo Korisnik.",
        ],
      },
    ],
  },
  {
    id: "kvkk",
    title: "Obaveštenje po KVKK",
    description:
      "Rukovalac podacima, svrhe obrade, pravni osnov, prenos i prava lica na koja se podaci odnose prema članu 10 Zakona br. 6698.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "Rukovalac podacima",
        paras: [
          `U skladu sa članom 10 turskog Zakona o zaštiti ličnih podataka br. 6698 („KVKK“), vaše lične podatke obrađuje ${OWNER} u svojstvu Rukovaoca, u obimu opisanom u nastavku.`,
        ],
      },
      {
        heading: "Obrađivani podaci i svrhe",
        bullets: [
          "Identitet/kontakt (ime, imejl): otvaranje naloga, autentifikacija, komunikacija.",
          "Transakcije klijenta (pretplata, plan, korišćenje): pružanje usluge, naplata, primena ograničenja.",
          "Bezbednost transakcija (sesija, IP, dnevnici): bezbednost, sprečavanje zloupotrebe, zakonska obaveza.",
          "Korisnički sadržaj (transkripti sesija, generisani slučajevi): pružanje softverske usluge i generisanje povratnih informacija.",
          "Članstvo u institucionalnoj kohorti (identifikator kohorte, period članstva): kada se korisnik pridruži kohorti koju vodi institucija, vidljivost za instruktora i administracija kohorte.",
        ],
      },
      {
        heading: "Pravni osnov (čl. 5)",
        bullets: [
          "Zaključenje/izvršenje ugovora: podaci neophodni za pružanje usluge.",
          "Legitimni interes rukovaoca: bezbednost, sprečavanje prevara, unapređenje sistema.",
          "Zakonska obaveza: čuvanje/izveštavanje koje proizlazi iz propisa.",
          "Izričita saglasnost: prenos u inostranstvo (čl. 9) i dodatna obrada koja nije strogo neophodna za uslugu.",
        ],
      },
      {
        heading: "Prenos u inostranstvo (čl. 9)",
        paras: [
          "Budući da su Platforma i njena baza podataka hostovane unutar Evropske unije, u data centru u Holandiji (Oracle Cloud), lični podaci korisnika koji se nalaze u Turskoj prenose se izvan Turske (u EU). Pored toga, radi generisanja odgovora veštačke inteligencije, sadržaj sesija i upiti mogu se preneti pružaocu AI usluge (Anthropic), čija se infrastruktura za obradu može nalaziti izvan EU/EEP (npr. u Sjedinjenim Američkim Državama).",
          "Ovi prenosi u inostranstvo potpadaju pod čl. 9 KVKK i oslanjaju se na odgovarajuće zaštitne mere, kao što su standardni ugovor / obavezujuća izjava koje objavljuje Odbor, ili, gde je potrebno, na vašu izričitu saglasnost. Sa pružaocima hostinga i usluga zaključuju se ugovori o obradi podataka (DPA).",
        ],
      },
      {
        heading: "Institucionalne kohorte i vidljivost za instruktora",
        paras: [
          "Ako se pridružite kohorti koju je otvorio univerzitet, klinika ili slična institucija, sadržaj vaših sesija (transkripte) i izveštaje supervizora može da vidi instruktor te kohorte tokom trajanja kohorte. Ova vidljivost obuhvata samo vaše sesije vezane za kohortu i prestaje kada prestane vaše članstvo u kohorti.",
          "Ovaj pristup se dobija preko POSEBNOG ekrana za izričitu saglasnost koji se prikazuje pri pridruživanju kohorti; on nije deo opšteg prihvatanja uslova Platforme. Ako tu saglasnost ne date, ne možete se pridružiti kohorti, ali možete nastaviti da koristite Platformu individualno, tačno kao i pre. Opoziv saglasnosti prekida vaše članstvo u kohorti i ne utiče na vaše individualno korišćenje.",
        ],
      },
      {
        heading: "Prava lica na koja se podaci odnose (čl. 11)",
        bullets: [
          "Da saznate da li se vaši lični podaci obrađuju i, ako se obrađuju, da zatražite informacije o tome.",
          "Da saznate svrhu obrade i da li se podaci koriste u skladu sa tom svrhom.",
          "Da znate treća lica kojima se podaci prenose u zemlji ili inostranstvu.",
          "Da zatražite ispravku nepotpune/netačne obrade i, kada su ispunjeni uslovi, brisanje/uništenje.",
          "Da uložite prigovor na rezultat na vašu štetu koji proizlazi isključivo iz automatizovane analize.",
          "Da zatražite naknadu štete pretrpljene usled nezakonite obrade.",
        ],
      },
      {
        heading: "Zahtevi",
        paras: [
          "Zahteve u vezi sa vašim pravima možete podneti preko kontakt kanala koji je objavio Rukovalac. Zahtevi se rešavaju u rokovima propisanim KVKK-om i njegovim podzakonskim aktima.",
        ],
      },
    ],
  },
  {
    id: "consent",
    title: "Izjava o izričitoj saglasnosti",
    description:
      "Odvojena od obaveštenja; slobodno data saglasnost za prenos u inostranstvo i AI obradu.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          "Izjavljujem da sam pročitao/la i razumeo/la Obaveštenje po KVKK i da slobodno, informisano i izričito pristajem na obradu opisanu u nastavku. (U skladu sa odlukom Odbora KVKK br. 2018/90, izričita saglasnost se pribavlja odvojeno od obaveze informisanja.)",
        ],
      },
      {
        heading: "Obrada na koju se daje saglasnost",
        bullets: [
          "Prenos mojih ličnih podataka izvan Turske, kao i njihovo čuvanje i obrada tamo, jer je Platforma hostovana u Evropskoj uniji (Holandija / Oracle Cloud) (čl. 9 KVKK).",
          "Prenos i obrada mojih transkripata sesija i upita kod pružaoca AI usluge (Anthropic), čija se infrastruktura za obradu može nalaziti izvan EU/EEP, u svrhu generisanja odgovora veštačke inteligencije (čl. 9 KVKK).",
          "Obrada u svrhu unapređenja proizvoda i analitike koja nije strogo neophodna za pružanje usluge.",
          "Primanje obaveštenja u vezi sa uslugom.",
        ],
      },
      {
        heading: "Opoziv saglasnosti",
        paras: [
          "Razumem da svoju izričitu saglasnost mogu opozvati u bilo kom trenutku; međutim, budući da je prenos u inostranstvo ka pružaocu AI usluge tehnički neophodan za funkcionisanje usluge, prihvatam da opoziv ove saglasnosti može dovesti do toga da ne mogu da koristim odgovarajuće funkcije ili uslugu u celini. Opoziv ne utiče na zakonitost obrade izvršene do datuma opoziva.",
        ],
      },
    ],
  },
  {
    // Counterpart of the TR "outreach" notice, see the comment there.
    id: "outreach",
    title: "Obaveštenje o kontaktnoj komunikaciji",
    description:
      "Za akademske i institucionalne kontakte koji su primili poslovni kontaktni imejl: odakle potiču podaci, zašto se obrađuju, pravni osnov i kako se odjaviti.",
    updated: "2026-08-06",
    sections: [
      {
        paras: [
          "Ovo obaveštenje informiše primaoce poslovnih kontaktnih imejlova koje PsyPractice šalje univerzitetskim odeljenjima za psihologiju i njihovom akademskom osoblju, u skladu sa članom 10 turskog Zakona o zaštiti ličnih podataka br. 6698 (KVKK) i Saopštenjem o postupcima i načelima ispunjavanja obaveze informisanja. Budući da vaši lični podaci nisu pribavljeni direktno od vas, informisanje se vrši najkasnije u trenutku prvog kontakta, zbog čega kontaktni imejl upućuje ovde.",
        ],
      },
      {
        heading: "1. Rukovalac podacima",
        bullets: [
          `Naziv: ${MERCHANT.legalName} (${OWNER_TYPE})`,
          `Adresa: ${MERCHANT.addressEn}`,
          `Poreska uprava / br.: ${MERCHANT.taxOffice} / ${MERCHANT.taxNo}`,
          `Imejl: ${MERCHANT.email}`,
          `Veb: ${MERCHANT.website}`,
        ],
      },
      {
        heading: "2. Obrađivani podaci i njihov izvor",
        paras: [
          "Obrada je ograničena na profesionalne kontakt podatke: ime, akademsko zvanje, univerzitet i odeljenje, institucionalnu imejl adresu i, kada je objavljen, institucionalni broj telefona.",
          "Ovi podaci nisu prikupljeni od vas, već su sastavljeni sa javno objavljenih zvaničnih stranica odeljenja i fakulteta univerziteta. Ne obrađuju se posebne kategorije podataka, a privatne (neinstitucionalne) imejl adrese ne koriste se za kontaktiranje.",
        ],
      },
      {
        heading: "3. Svrha",
        paras: [
          "Vaši podaci se obrađuju kako bi vam se predstavio softverski alat namenjen studentima psihologije, kako bi vaše odeljenje bilo pozvano na mogući razgovor o pilotu ili saradnji i kako bi se vodila prepiska u vezi sa tim. Ne koriste se ni u koju drugu svrhu, ne prodaju se i ne prenose trećim stranama u marketinške svrhe.",
        ],
      },
      {
        heading: "4. Pravni osnov",
        paras: [
          "Obrada se oslanja na legitimne interese rukovaoca prema članu 5/2-(f) KVKK, pod uslovom da to ne šteti vašim osnovnim pravima i slobodama: kontakt se ostvaruje samo na institucionalnu adresu, samo u vezi sa temom koja je direktno povezana sa profesionalnom oblašću primaoca i ograničen broj puta.",
          "Sama činjenica da su podaci javno dostupni na internetu nije sama po sebi pravni osnov. Odbor za zaštitu ličnih podataka zauzeo je stav da javnost podataka ne čini te podatke upotrebljivim u svaku svrhu i da se namera i svrha njihovog objavljivanja moraju posebno oceniti; stoga se na član 5/2-(d) ne oslanja.",
        ],
      },
      {
        heading: "5. Prenosi i čuvanje",
        paras: [
          "Prepiska se vodi preko pružaoca imejl usluge čija se infrastruktura može nalaziti u inostranstvu; takvi prenosi vrše se uz odgovarajuće zaštitne mere prema članu 9 KVKK.",
          "Vaši podaci se brišu kada prestane svrha kontakta ili na vaš zahtev. Nakon zahteva za brisanje, čuva se strogo ograničena evidencija „ne kontaktirati“ isključivo da bi se osiguralo da ne budete ponovo kontaktirani; ona se nikada ne koristi za kontaktiranje.",
        ],
      },
      {
        heading: "6. Komercijalne elektronske poruke i pravo na odbijanje",
        paras: [
          "Promotivne poruke potpadaju pod Zakon br. 6563 o uređenju elektronske trgovine. Možete odbiti da ih primate bez navođenja razloga; odbijanja se obrađuju najkasnije u roku od tri radna dana, nakon čega se više ne šalje nijedna promotivna poruka. Dovoljno je odgovoriti na primljeni imejl ili pisati na " + MERCHANT.email + ".",
        ],
      },
      {
        heading: "7. Vaša prava",
        paras: [
          "Prema članu 11 KVKK imate pravo da saznate da li se vaši lični podaci obrađuju, da zatražite informacije o tome, da saznate svrhu obrade i da li se podaci koriste u skladu sa njom, da znate treća lica kojima se prenose u Turskoj ili inostranstvu, da zatražite ispravku nepotpunih ili netačnih podataka, da zatražite brisanje ili uništenje, da zatražite da se o tim radnjama obaveste treća lica, da uložite prigovor na rezultat na vašu štetu koji je proizveden isključivo automatizovanom analizom i da zatražite naknadu pretrpljene štete.",
          `Zahtevi se mogu poslati na ${MERCHANT.email} i na njih se odgovara najkasnije u roku od trideset dana. Zadržavate i pravo da podnesete pritužbu Odboru za zaštitu ličnih podataka.`,
        ],
      },
    ],
  },
  {
    id: "cookies",
    title: "Politika kolačića",
    description: "Vrste kolačića koji se koriste, njihove svrhe i upravljanje podešavanjima.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          "Platforma koristi kolačiće i slične tehnologije lokalnog skladištenja (localStorage) da održi vašu sesiju i zapamti vaša podešavanja.",
        ],
      },
      {
        heading: "Korišćene tehnologije",
        bullets: [
          "Strogo neophodni: token sesije/autentifikacije, bezbednost. Usluga ne radi bez njih.",
          "Funkcionalni: jezičko podešavanje (NEXT_LOCALE), podešavanja interfejsa (npr. tema).",
          "Performanse/bezbednost: tehnički dnevnici za ograničenje učestalosti i otkrivanje zloupotrebe.",
        ],
      },
      {
        heading: "Upravljanje podešavanjima",
        paras: [
          "Kolačiće možete obrisati ili blokirati u svom pregledaču; međutim, blokiranje strogo neophodnih kolačića onemogućiće prijavu i osnovne funkcije. U skladu sa načelima GDPR / ePrivacy i Vodičem za kolačiće KVKK, kolačići koji nisu neophodni koriste se samo na osnovu vašeg izričitog izbora/saglasnosti.",
        ],
      },
    ],
  },
  {
    id: "about",
    title: "O nama",
    description:
      "Svrha PsyPractice-a, usluga koju nudi i kontakt podaci prodavca.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          "PsyPractice je platforma za simulaciju pacijenata i kliničke veštine uz podršku veštačke inteligencije, napravljena za studente psihologije i novodiplomirane kliničare na početku karijere. Korisnici vode tekstualne terapijske sesije; na kraju svake sesije supervizor AI procenjuje razgovor i proizvodi razvojni izveštaj sa povratnim informacijama. Pacijent AI prenosi terapijski odnos iz sesije u sesiju putem pamćenja kroz više sesija.",
        ],
      },
      {
        heading: "Naša misija",
        paras: [
          "Naš cilj je da budućim stručnjacima za mentalno zdravlje pružimo bezbedno okruženje koje se može ponavljati, u kojem vežbaju veštine vođenja razgovora bez ikakvog rizika da naškode stvarnim klijentima. PsyPractice nije usluga obrazovanja ni nastave; to je softverski alat kojim korisnik sam sprovodi i beleži sopstveno vežbanje. Nije prava terapija ni savetovanje, nije zamena za kliničku superviziju, nije dijagnostički instrument ni instrument za procenu i ne sme se koristiti u krizama ni hitnim situacijama.",
        ],
      },
      {
        heading: "Šta nudimo",
        bullets: [
          "Simulaciju tekstualnih terapijskih sesija sa raznovrsnim profilima pacijenata sintetizovanim iz kliničke literature.",
          "Automatizovane izveštaje supervizora sa procenom posle svake sesije.",
          "Model „živog pacijenta“ sa pamćenjem kroz više sesija, koji vremenom razvija terapijski odnos.",
          "Generisanje prilagođenih pacijenata, kojim studenti kreiraju sopstvene AI slučajeve.",
          "Metrike napretka koje prate razvoj mikroveština.",
        ],
      },
      {
        heading: "Podaci o prodavcu / poslovanju",
        bullets: [
          `Poslovno ime: ${MERCHANT.legalName} (${OWNER_TYPE})`,
          `Adresa: ${MERCHANT.addressEn}`,
          `Poreska uprava / br.: ${MERCHANT.taxOffice} / ${MERCHANT.taxNo}`,
          `Imejl: ${MERCHANT.email}`,
          `Veb: ${MERCHANT.website}`,
        ],
      },
    ],
  },
  {
    id: "distance-sales",
    title: "Ugovor o prodaji na daljinu",
    description:
      "Prodavac, kupac, usluga, cena, plaćanje, izvršenje i uslovi prava na odustanak prema turskom Zakonu br. 6502 i Pravilniku o ugovorima na daljinu.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "1. Strane",
        bullets: [
          `PRODAVAC: ${MERCHANT.legalName} (${OWNER_TYPE}). Adresa: ${MERCHANT.addressEn}. Poreska uprava/br.: ${MERCHANT.taxOffice} / ${MERCHANT.taxNo}. Imejl: ${MERCHANT.email}.`,
          "KUPAC: fizičko ili pravno lice koje otvara nalog na Platformi i kupuje plaćenu pretplatu („Kupac“).",
        ],
      },
      {
        heading: "2. Predmet Ugovora",
        paras: [
          "Predmet ovog Ugovora je utvrđivanje prava i obaveza strana, u skladu sa turskim Zakonom br. 6502 o zaštiti potrošača i Pravilnikom o ugovorima na daljinu, u vezi sa prodajom i izvršenjem pretplate na digitalnu uslugu koju Kupac elektronski kupuje preko Platforme, a čije su karakteristike i prodajna cena navedene u nastavku.",
        ],
      },
      {
        heading: "3. Priroda usluge i cena",
        bullets: [
          "Prodata usluga su funkcije simulacije pacijenata uz podršku veštačke inteligencije koje se nude u okviru plaćenog pretplatničkog plana softvera PsyPractice (digitalna usluga / pravo korišćenja softvera).",
          "PsyPractice nije usluga obrazovanja ni nastave; to je softverski alat kojim korisnik sam sprovodi i beleži sopstveno vežbanje. Pretplatnička naknada je naknada za pristup tom softveru; ona nije naknada za časove, nastavni plan, ispite, konsultacije ni bilo koji dokument.",
          "Sadržaj plana, trajanje (mesečno, period od 4 meseca ili godišnje) i važeća cena jasno se prikazuju na stranici sa cenama/plaćanjem Platforme u trenutku kupovine; ukupan iznos sa uključenim porezima saopštava se Kupcu pre plaćanja.",
          "Cene važe u valuti prikazanoj na Platformi; ako se ne otkaže, pretplata se automatski obnavlja po istoj ceni na kraju izabranog perioda.",
          "Kod planova koji se nude kao „neograničene sesije“, korišćenje podleže ograničenju fer korišćenja (trenutno 60 sesija po kalendarskom mesecu). Kada se ograničenje dostigne, nove sesije se mogu ponovo započeti od prvog dana narednog kalendarskog meseca; to ne daje pravo na umanjenje cene ni povraćaj novca. Ograničenje služi sprečavanju deljenja naloga i automatizovanog korišćenja, i Prodavac ga ne menja na štetu Kupca tokom plaćenog perioda pretplate.",
        ],
      },
      {
        heading: "4. Plaćanje",
        paras: [
          "Plaćanja se bezbedno naplaćuju kreditnom/debitnom karticom preko licencirane platne institucije iyzico. Prodavac ne čuva podatke o kartici; plaćanje se obrađuje kroz bezbedne sisteme iyzico. Kod ponavljajućih (pretplatničkih) plaćanja iznos se automatski naplaćuje u svakom periodu obnavljanja sa kartice koju je Kupac odobrio.",
        ],
      },
      {
        heading: "5. Izvršenje i isporuka",
        paras: [
          "Usluga je digitalna i ne uključuje fizičku isporuku. Po potvrdi plaćanja, funkcije pretplate odmah postaju dostupne na nalogu Kupca. Izvršenje se odvija elektronski, obezbeđivanjem neprekidnog pristupa tokom celog perioda pretplate.",
        ],
      },
      {
        heading: "6. Pravo na odustanak i njegov izuzetak",
        bullets: [
          "U skladu sa članom 15/1-(ğ) Pravilnika o ugovorima na daljinu, pravo na odustanak ne može se koristiti za nematerijalnu (digitalnu) robu/usluge koje se izvršavaju trenutno u elektronskom obliku, kada je izvršenje započelo uz saglasnost Kupca.",
          "Kupac u trenutku kupovine prihvata da će usluga biti izvršena odmah i da, stoga, pravo na odustanak ne postoji. Kupac može u bilo kom trenutku otkazati pretplatu kako bi zaustavio obnavljanje; otkazivanje stupa na snagu na kraju tekućeg plaćenog perioda.",
          "Detaljne uslove povraćaja pogledajte u „Uslovima isporuke i povraćaja“.",
        ],
      },
      {
        heading: "7. Sporovi i stupanje na snagu",
        paras: [
          "U slučaju spora, Kupac se može obratiti Potrošačkom arbitražnom odboru ili potrošačkim sudovima u mestu svog prebivališta, u okviru novčanih granica koje objavljuje Ministarstvo trgovine. Ovaj Ugovor se zaključuje i stupa na snagu odobrenjem Kupca u elektronskom obliku.",
        ],
      },
    ],
  },
  {
    id: "delivery-refund",
    title: "Uslovi isporuke i povraćaja",
    description:
      "Isporuka digitalne usluge, otkazivanje pretplate, izuzetak od prava na odustanak i uslovi povraćaja.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "Isporuka (digitalna usluga)",
        bullets: [
          "PsyPractice je u potpunosti digitalna usluga; nema slanja fizičkog proizvoda ni kurirske dostave.",
          "U trenutku potvrde plaćanja, funkcije pretplate se automatski i odmah aktiviraju na nalogu Kupca; ne postoji poseban rok isporuke ni naknada za isporuku.",
          "Usluzi se pristupa preko veb pregledača na bilo kom uređaju povezanom na internet.",
        ],
      },
      {
        heading: "Otkazivanje pretplate",
        bullets: [
          "Kupac može otkazati pretplatu u bilo kom trenutku iz podešavanja naloga. Otkazivanje stupa na snagu na kraju tekućeg plaćenog perioda i zaustavlja sledeće automatsko obnavljanje.",
          "Nakon otkazivanja, pristup usluzi se nastavlja do kraja plaćenog perioda.",
        ],
      },
      {
        heading: "Pravo na odustanak i povraćaj",
        bullets: [
          "Budući da je usluga digitalna usluga koja se izvršava odmah uz saglasnost Kupca, po pravilu ne nastaje pravo na odustanak, pa time ni pravo na povraćaj, prema članu 15/1-(ğ) Pravilnika o ugovorima na daljinu.",
          "U slučajevima očiglednog nedostatka, kao što su pogrešna/dvostruka naplata, potpuna nemogućnost pristupa usluzi iz tehničkih razloga ili slično, Kupac može zatražiti povraćaj tako što će se obratiti Prodavcu u razumnom roku od datuma plaćanja.",
          `Zahtevi za povraćaj šalju se na ${MERCHANT.email}; odobreni povraćaji vraćaju se na karticu kojom je izvršeno plaćanje, preko infrastrukture iyzico, po pravilu u roku od 14 dana. Rok povraćaja može varirati u zavisnosti od vremena obrade u banci.`,
        ],
      },
      {
        heading: "Kontakt",
        paras: [
          `Za sva pitanja u vezi sa isporukom, otkazivanjem i povraćajem: ${MERCHANT.email}${MERCHANT.phone ? " · " + MERCHANT.phone : ""}.`,
        ],
      },
    ],
  },
];
